<div class="flex flex-col font-medium py-1 px-1 lg:px-4">
  <h4 class="text-3xl">{{ numero }}</h4>

  <div class="flex justify-between text-xss lg:text-xs">
    <span>{{ dia | titlecase }}</span>
    <span>0{{ quantidadeHoras }}h</span>
  </div>
</div>
